// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/count.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'count',
	post: false,
	require: function(config, filter) { return sorted('count', filter) > 0 },
	run: function(config, filter, data, query) {
		var reverse = sortReverse('count', filter)
		var priority = sortPriority('count', filter)
		query.where('g.game_players_min', '>', 0)
		if (reverse) {
			query.order('g.game_players_max', true, priority)
		} else {
			query.order('g.game_players_min', false, priority)
		}
	}
}
